// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ListItemIcon":"bcu_a bie_ke","ListItemIcon--empty":"bcu_b bie_fl"};